import React from 'react';
import Alert from '@mui/material/Alert';
import Link from '@mui/material/Link';
import { Link as RouterLink, useLocation } from 'react-router-dom';

/**
 * Displays an informational alert prompting the user to log in.
 *
 * @param {string} message - Message displayed after the "Log in" link.
 * @param {string} [from] - Path to store in the router state for redirect
 *   after signing in. Defaults to the current location pathname.
 * @param {object} [sx] - MUI style overrides for the Alert component.
 * @param {string} [severity="info"] - MUI Alert severity variant.
 */
function LoginPromptAlert({ message, from, sx, severity = 'info' }) {
  const location = useLocation();
  const fromPath = from !== undefined ? from : location.pathname;

  return (
    <Alert severity={severity} sx={sx}>
      <Link
        component={RouterLink}
        to="/sign-in"
        state={{ from: fromPath }}
        underline="hover"
        color="primary"
        fontWeight="bold"
      >
        Log in
      </Link>{' '}
      {message}
    </Alert>
  );
}

export default LoginPromptAlert;
